import { render, staticRenderFns } from "./pending_requests.vue?vue&type=template&id=383abd93&scoped=true&"
import script from "./pending_requests.vue?vue&type=script&lang=js&"
export * from "./pending_requests.vue?vue&type=script&lang=js&"
import style0 from "./pending_requests.vue?vue&type=style&index=0&id=383abd93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383abd93",
  null
  
)

export default component.exports